import type { ListUserStores200 } from '@metapic-apps/shared'
import { computed, type Ref, ref, watch } from 'vue'

import { normalizeCreatorAdvertisers } from '@/lib/adapters/creator-advertisers.adapter'
import { useApi } from '@/lib/helpers/api.helpers'
import { request } from '@/lib/services'

const PAGE_SIZE = 200

export const useGetCreatorAdvertisers = (userId: Ref<number>, query: Ref<string>) => {
  const page = ref(1)

  watch(
    [userId, query],
    () => {
      page.value = 1
    },
    { immediate: true, deep: true },
  )

  const {
    data: response,
    isLoading,
    error,
    fetchData: refetch,
  } = useApi(() =>
    request.get<ListUserStores200>(`/v2/users/${userId.value}/advertisers`, {
      params: {
        'include[]': ['campaign.internal_name'],
        page: page.value,
        size: PAGE_SIZE,
        q: query.value.trim() || undefined,
        sort_by: 'name:asc',
      },
    }),
  )

  const data = computed(() => normalizeCreatorAdvertisers(response.value?.data.data ?? []))
  const total = computed(() => response.value?.data.meta.total ?? 0)
  const totalPages = computed(() => response.value?.data.meta.last_page ?? 0)

  return { data, total, totalPages, page, isLoading, error, refetch }
}
